import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-toolbar-button',
  templateUrl: './ui-toolbar-button.component.html',
  styleUrls: ['./ui-toolbar-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiToolbarButtonComponent {
  @Input() active = false;
  @Input() open = false;
  @Input() disabled = false;
  @Input() ariaLabel = '';
  @Input() ariaExpanded: boolean | null = null;

  @Output() pressed = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (this.disabled) {
      return;
    }
    this.pressed.emit(event);
  }
}
